import React, { useState } from "react";
import { SlDrawer, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { useForm } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";

function AddPOC(props) {
  const [mobileClicked, setMobileClicked] = useState(false);
  const [emailClicked, setEmailClicked] = useState(false);

  const [selected1mobile, setSelected1Mobile] = useState("personal");
  const [selected1Email, setSelected1Email] = useState("personal");
  const [selected2mobile, setSelected2Mobile] = useState("personal");
  const [selected2Email, setSelected2Email] = useState("personal");

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  const watchMobile = watch("mobile");
  const watchEmail = watch("poc_email");

  const handlevalidate = () => {
    if (mobileClicked && selected1mobile === selected2mobile) {
      Toast("error", "You can't add two same type mobile numbers.");
      return false;
    }
    if (emailClicked && selected1Email === selected2Email) {
      Toast("error", "You can't add two same type emails.");
      return false;
    }
    return true;
  };

  const onSubmit = async (data) => {
    const result = handlevalidate();
    if (result) {
      let obj = {
        brand_id: props.brand.brand_id,
        name: data.poc_name,
        designation: data.poc_designation,
        isAgency: data.isAgency,
        // Email handling
        ...{
          [selected1Email === 'personal' ? 'personal_email' : 'official_email']: data.poc_email,
          ...(emailClicked && {
            [selected2Email === 'personal' ? 'personal_email' : 'official_email']: data.poc_email1
          })
        },
        // Mobile handling
        ...{
          [selected1mobile === 'personal' ? 'personal_mobile' : 'official_mobile']: data.mobile,
          ...(mobileClicked && {
            [selected2mobile === 'personal' ? 'personal_mobile' : 'official_mobile']: data.mobile1
          })
        }
      };
    
      try {
        let res = await API({
          url: "/accountManagement/add_poc",
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res.code === 200) {
          Toast("success", "Contact Added Successfully!");
          props.setShow(false);
          props.loadData();
        } else {
          Toast("error", res.data?.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <SlDrawer
        label="POC"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        noHeader={true}
        className="from-bottom"
      >
        <div className="px-2 pt-2 relative">
          <h3>Add POC</h3>
          <p className="text-gray-500 text-xs mt-1">{props.brand.name}</p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                placeholder="Client Name"
                {...register("poc_name", { required: true })}
              />
              {errors.poc_name && <p className="text-red-600">Please Enter Name</p>}
            </div>
            <div className="mb-3">
              <label className="form-label">Designation</label>
              <input
                className="form-control"
                placeholder="Designation"
                {...register("poc_designation", { required: true })}
              />
              {errors.poc_designation && <p className="text-red-600">Please Enter Designation</p>}
            </div>
            <div className="border-b-[2px] border-dotted mb-3"></div>
            <p className="text-gray-500 text-xs">Client Contact details</p>
            <div className="mb-3">
              <label className="form-label">Mobile Number</label>
              <div className="d-flex w-full form-control custom-field">
                <input
                  placeholder="xxxxxxxxxx"
                  {...register("mobile", { required: (!watchMobile && !watchEmail), pattern: { value: /^(?:\+91[-\s]?)?(?:[6-9]\d{9}|0\d{10})$/, message: "Invalid mobile number" } })}
                />
                <select className="form-select" onChange={(e) => setSelected1Mobile(e.target.value)}>
                  <option value="personal">Personal</option>
                  <option value="office">Office</option>
                </select>
              </div>
              {errors.mobile && <p className="text-red-600">{errors.mobile.message || 'Please Enter Mobile Number'}</p>}
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <div className="d-flex form-control custom-field">
                <input
                  placeholder="brand@way2news.com"
                  {...register("poc_email", { required: (!watchMobile && !watchEmail), pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Invalid email" } })}
                />
                <select className="form-select" onChange={(e) => setSelected1Email(e.target.value)}>
                  <option value="personal">Personal</option>
                  <option value="office">Office</option>
                </select>
              </div>
              {errors.poc_email && <p className="text-red-600">{errors.poc_email.message || 'Please Enter Email'}</p>}
            </div>
            {mobileClicked && (
              <div className="mb-3">
                <div className="d-flex justify-between">
                  <label className="form-label">Mobile Number</label>
                  <SlIcon
                    className="text-xs text-red-600 cursor-pointer"
                    name="x-circle"
                    onClick={() => setMobileClicked(false)}
                  />
                </div>
                <div className="d-flex w-full form-control custom-field">
                  <input
                    placeholder="xxxxxxxxxx"
                    {...register("mobile1", { required: true })}
                  />
                  <select className="form-select" onChange={(e) => setSelected2Mobile(e.target.value)}>
                    <option value="personal">Personal</option>
                    <option value="office">Office</option>
                  </select>
                </div>
                {errors.mobile1 && <p className="text-red-600">Please Enter Mobile Number</p>}
              </div>
            )}
            {emailClicked && (
              <div className="mb-3">
                <div className="d-flex justify-between">
                  <label className="form-label">Email</label>
                  <SlIcon
                    className="text-xs text-red-600 cursor-pointer"
                    name="x-circle"
                    onClick={() => setEmailClicked(false)}
                  />
                </div>
                <div className="d-flex form-control custom-field">
                  <input
                    placeholder="brand@way2news.com"
                    {...register("poc_email1", { required: true })}
                  />
                  <select className="form-select" onChange={(e) => setSelected2Email(e.target.value)}>
                    <option value="personal">Personal</option>
                    <option value="office">Office</option>
                  </select>
                </div>
                {errors.poc_email1 && <p className="text-red-600">Please Enter Email</p>}
              </div>
            )}
            <div className="mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" {...register("isAgency")} />
              <label class="form-check-label" for="defaultCheck1">
                IsAgency
              </label>
            </div>
              </div>
            <div className="mb-3 d-flex gap-2.5">
              {!mobileClicked && (
                <button
                  onClick={() => setMobileClicked(true)}
                  className="border-[1px] text-xs px-3 py-1 rounded-full hover:text-white hover:bg-black"
                >
                  + Add mobile
                </button>
              )}
              {!emailClicked && (
                <button
                  onClick={() => setEmailClicked(true)}
                  className="border-[1px] text-xs px-3 py-1 rounded-full hover:text-white hover:bg-black"
                >
                  + Add email
                </button>
              )}
            </div>
            <div>
              <button
                className="w-100 bg-[#0079BC] px-4 py-3 text-white font-bold text-xs rounded"
                type="submit"
              >
                Save Details
              </button>
            </div>
          </form>
          <SlIcon
            className="absolute top-3 right-6 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => props.setShow(false)}
          />
        </div>
      </SlDrawer>
    </>
  );
}

export default AddPOC;
